import React from 'react';
import { Coin } from '../../data/coins';
import { CoinBadges } from './CoinBadges';
import { DetailedCoin } from '../types';
import './AlbumMenu.css';

interface AlbumTooltipProps {
  coin: Coin | null;
  count: number;
  position: { x: number; y: number } | null;
}

export const AlbumTooltip: React.FC<AlbumTooltipProps> = ({ coin, count, position }) => {
  if (!coin || !position) return null;

  const detailedCoin: DetailedCoin = {
    ...coin,
    strikeType: coin.mintage === 0 ? 'In Sets / Collector' : (coin.type === 'commemorative' ? 'Commemorative Circulation' : 'Standard Circulation'),
    mintmark: coin.mintmark || 'None',
    timesFoundSoFar: count
  };

  return (
    <div
      className="album-tooltip-box"
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`
      }}
    >
      <div className="tooltip-header-row">
        <span className="tooltip-country-year">{coin.country} ({coin.year})</span>
        <CoinBadges
          coin={detailedCoin}
          inline={true}
          timesFoundSoFar={count}
          showRarityBadge={true}
          revealed={true}
        />
      </div>

      <div className="tooltip-coin-title">{coin.name}</div>

      {coin.subject && (
        <div className="tooltip-coin-subject">
          <strong>Subject:</strong> {coin.subject}
        </div>
      )}

      {coin.description && (
        <div className="tooltip-coin-desc">{coin.description}</div>
      )}

      <div className="tooltip-coin-mintage">
        Mintage: <strong>{coin.mintageFormatted || coin.mintage.toLocaleString()}</strong>
        {count > 0 && <span className="tooltip-owned-tag">Collected: {count}×</span>}
      </div>
    </div>
  );
};
